export const CART_ID_KEY = `cart_id`;

export const defaultModalModelData = {
  isActive: false,
  isInit: false,
};

export const defaultModalShareCartTriggerModelData = {
  isClicking: false,
  isModalShown: false
};

export const ActionType = {
  CLICKING: `CLICKING`,
  SHOW_MODAL: `SHOW_MODAL`,
  RENDER_DATA: `RENDER_DATA`
};

export const MODAL_MAIN_CLASS = `share-cart-modal-wrapper`;

export const CONNECTOR_URL = `/assets/components/savedcarts/connector.php`;

export const RequestAction = {
  SAVE_CART: `save_cart`
};
